import { lazy, ReactElement, RefObject, Suspense } from 'react';

const CustomTooltip = lazy(() => import('../CustomTooltip/CustomTooltip'));

const RAIL_TOOLTIP_PLACEMENT = 'right';

const NULL_PREVIEW_REF: RefObject<HTMLElement | null> = { current: null };

interface SidebarRailTooltipProps {
  label: string;
  isDisabled?: boolean;
  children: ReactElement;
}

export function SidebarRailTooltip({
  label,
  isDisabled,
  children,
}: Readonly<SidebarRailTooltipProps>) {
  return (
    <Suspense fallback={children}>
      <CustomTooltip
        value={label}
        previewRef={NULL_PREVIEW_REF}
        placement={RAIL_TOOLTIP_PLACEMENT}
        hasArrow={false}
        isDisabled={isDisabled}
      >
        {children}
      </CustomTooltip>
    </Suspense>
  );
}
